import { render, staticRenderFns } from "./SavedSearchOpportunityCard.vue?vue&type=template&id=33b4d98e&scoped=true"
import script from "./SavedSearchOpportunityCard.vue?vue&type=script&lang=js"
export * from "./SavedSearchOpportunityCard.vue?vue&type=script&lang=js"
import style0 from "./SavedSearchOpportunityCard.vue?vue&type=style&index=0&id=33b4d98e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b4d98e",
  null
  
)

export default component.exports